import React from "react";
import { Sparkles } from "lucide-react";
import "./ProgramDetails.custom.css";

const allTools = {
  python: {
    name: "Python",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.898 2C8.01 2 8.27 3.682 8.27 3.682l.006 1.748h3.766s1.119-.074 1.119 1.11v2.806h-5.27S4.137 9.176 4.137 12.898c0 3.723 3.327 3.593 3.327 3.593h1.993v-2.776s-.052-1.285 1.222-1.285h5.163s1.236.037 1.236-1.147V6.012s-.019-4.012-5.19-4.012z" fill="url(#py-grad-1)"/>
        <path d="M12.102 22c3.888 0 3.628-1.682 3.628-1.682l-.006-1.748h-3.766s-1.119.074-1.119-1.11v-2.806h5.27s3.754.17 3.754-3.552c0-3.722-3.327-3.593-3.327-3.593h-1.993v2.776s.052 1.285-1.222 1.285h-5.163s-1.236-.037-1.236 1.147v5.271s.019 4.012 5.19 4.012z" fill="url(#py-grad-2)"/>
        <defs>
          <linearGradient id="py-grad-1" x1="4.137" y1="2" x2="16.035" y2="11.346" gradientUnits="userSpaceOnUse">
            <stop stopColor="#387EB8"/>
            <stop offset="1" stopColor="#366994"/>
          </linearGradient>
          <linearGradient id="py-grad-2" x1="7.965" y1="12.654" x2="19.863" y2="22" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FFE873"/>
            <stop offset="1" stopColor="#FFD43B"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-blue-500/10 to-cyan-500/5",
  },
  chatgpt: {
    name: "ChatGPT",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm3.8 13.5l-3.3-1.9a1 1 0 01-.5-.8V9.1a1 1 0 011.5-.8l3.3 1.9a1 1 0 01.5.8v3.7a1 1 0 01-1.5.8zm-4.3-5L8.2 8.6a1 1 0 01-.5-.8V4.1a1 1 0 011.5-.8l3.3 1.9A1 1 0 0113 6v3.7a1 1 0 01-1.5.8zm.5 5l3.3 1.9a1 1 0 01.5.8v3.7a1 1 0 01-1.5.8L12.2 20a1 1 0 01-.5-.8v-3.7a1 1 0 011.5-.8z" fill="url(#gpt-grad)"/>
        <defs>
          <linearGradient id="gpt-grad" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
            <stop stopColor="#10a37f"/>
            <stop offset="1" stopColor="#0d8668"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-emerald-500/10 to-teal-500/5",
  },
  openai: {
    name: "OpenAI API",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 12a7 7 0 11-7-7 7 7 0 017 7z" stroke="url(#oa-grad)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 9v6M9 12h6" stroke="url(#oa-grad)" strokeWidth="2" strokeLinecap="round"/>
        <defs>
          <linearGradient id="oa-grad" x1="5" y1="5" x2="19" y2="19" gradientUnits="userSpaceOnUse">
            <stop stopColor="#4F46E5"/>
            <stop offset="1" stopColor="#06B6D4"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-indigo-500/10 to-cyan-500/5",
  },
  huggingface: {
    name: "Hugging Face",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" fill="url(#hf-grad)"/>
        <path d="M8 11.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" fill="#fff"/>
        <path d="M9 16c1.5 1.5 4.5 1.5 6 0" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
        <defs>
          <linearGradient id="hf-grad" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FFD21E"/>
            <stop offset="1" stopColor="#FF8F00"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-amber-500/10 to-yellow-500/5",
  },
  gemini: {
    name: "Gemini",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2l2.5 6.5L21 11l-6.5 2.5L12 20l-2.5-6.5L3 11l6.5-2.5L12 2z" fill="url(#gem-grad)"/>
        <path d="M18 4l1 2.5L21.5 7l-2.5 1L18 10.5l-1-2.5-2.5-1 2.5-1L18 4z" fill="url(#gem-grad)"/>
        <defs>
          <linearGradient id="gem-grad" x1="3" y1="2" x2="21.5" y2="20.5" gradientUnits="userSpaceOnUse">
            <stop stopColor="#1A73E8"/>
            <stop offset="0.5" stopColor="#7E52E8"/>
            <stop offset="1" stopColor="#E11D48"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-blue-500/10 to-rose-500/5",
  },
  langchain: {
    name: "LangChain",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 10a3 3 0 013-3h4a3 3 0 010 6h-4a3 3 0 01-3-3z" stroke="url(#lc-grad)" strokeWidth="2.5"/>
        <path d="M15 14a3 3 0 01-3 3H8a3 3 0 010-6h4a3 3 0 013 3z" stroke="url(#lc-grad)" strokeWidth="2.5"/>
        <defs>
          <linearGradient id="lc-grad" x1="5" y1="7" x2="19" y2="17" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FF6B6B"/>
            <stop offset="1" stopColor="#FF8E53"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-red-500/10 to-orange-500/5",
  },
  chromadb: {
    name: "ChromaDB",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="18" height="18" rx="5" stroke="url(#chr-grad)" strokeWidth="2.5"/>
        <circle cx="9" cy="9" r="2.5" fill="url(#chr-grad)"/>
        <circle cx="15" cy="15" r="2.5" fill="url(#chr-grad)"/>
        <defs>
          <linearGradient id="chr-grad" x1="3" y1="3" x2="21" y2="21" gradientUnits="userSpaceOnUse">
            <stop stopColor="#EC4899"/>
            <stop offset="1" stopColor="#8B5CF6"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-pink-500/10 to-purple-500/5",
  },
  streamlit: {
    name: "Streamlit",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L4 12h7v10l8-10h-7V2z" fill="url(#st-grad)"/>
        <defs>
          <linearGradient id="st-grad" x1="4" y1="2" x2="19" y2="22" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FF4B4B"/>
            <stop offset="1" stopColor="#FF8F8F"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-red-500/10 to-rose-500/5",
  },
  react: {
    name: "React.js",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="12" cy="12" rx="3" ry="9" transform="rotate(30 12 12)" stroke="url(#react-grad)" strokeWidth="2"/>
        <ellipse cx="12" cy="12" rx="3" ry="9" transform="rotate(90 12 12)" stroke="url(#react-grad)" strokeWidth="2"/>
        <ellipse cx="12" cy="12" rx="3" ry="9" transform="rotate(150 12 12)" stroke="url(#react-grad)" strokeWidth="2"/>
        <circle cx="12" cy="12" r="2" fill="url(#react-grad)"/>
        <defs>
          <linearGradient id="react-grad" x1="4" y1="4" x2="20" y2="20" gradientUnits="userSpaceOnUse">
            <stop stopColor="#61DAFB"/>
            <stop offset="1" stopColor="#005A9C"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-cyan-500/10 to-blue-500/5",
  },
  nodejs: {
    name: "Node.js",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L4 7v10l8 5 8-5V7l-8-5zm6 13.5l-6 3.5-6-3.5V8.5l6-3.5 6 3.5v7z" fill="url(#node-grad)"/>
        <defs>
          <linearGradient id="node-grad" x1="4" y1="2" x2="20" y2="22" gradientUnits="userSpaceOnUse">
            <stop stopColor="#339933"/>
            <stop offset="1" stopColor="#1E5C1E"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-green-500/10 to-emerald-500/5",
  },
  mongodb: {
    name: "MongoDB",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C9.5 7.5 8 11.5 8 14.5c0 3.3 1.8 5.5 4 5.5s4-2.2 4-5.5c0-3-1.5-7-4-12.5z" fill="url(#mg-grad)"/>
        <defs>
          <linearGradient id="mg-grad" x1="8" y1="2" x2="16" y2="20" gradientUnits="userSpaceOnUse">
            <stop stopColor="#47A248"/>
            <stop offset="1" stopColor="#13AA52"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-emerald-500/10 to-green-500/5",
  },
  aws: {
    name: "AWS",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L2 7v10l10 5 10-5V7L12 2zm8 14.5L12 20l-8-3.5V8.5L12 5l8 3.5v8z" fill="url(#aws-grad)"/>
        <defs>
          <linearGradient id="aws-grad" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FF9900"/>
            <stop offset="1" stopColor="#CC7A00"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-orange-500/10 to-amber-500/5",
  },
  git: {
    name: "Git",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.3 12c0-.5.2-1 .6-1.4l9.1-9.1c.8-.8 2-.8 2.8 0l9.1 9.1c.8.8.8 2 0 2.8l-9.1 9.1c-.8.8-2 .8-2.8 0L2.9 13.4c-.4-.4-.6-.9-.6-1.4zm9.7 4.1c.3.3.8.3 1.1 0l3-3c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-1.6 1.6V8.4c0-.4-.3-.8-.8-.8s-.8.4-.8.8v5.2l-1.6-1.6c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1l3 3z" fill="url(#git-grad)"/>
        <defs>
          <linearGradient id="git-grad" x1="2.3" y1="1.5" x2="21.7" y2="22.5" gradientUnits="userSpaceOnUse">
            <stop stopColor="#F05032"/>
            <stop offset="1" stopColor="#B83A20"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-red-500/10 to-orange-500/5",
  },
  sql: {
    name: "SQL",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.5 2 2 4.2 2 7v10c0 2.8 4.5 5 10 5s10-2.2 10-5V7c0-2.8-4.5-5-10-5zm0 17c-4.4 0-8-1.6-8-3v-2.2c1.9 1.4 4.8 2.2 8 2.2s6.1-.8 8-2.2V16c0 1.4-3.6 3-8 3zm0-5c-4.4 0-8-1.6-8-3v-2.2c1.9 1.4 4.8 2.2 8 2.2s6.1-.8 8-2.2V11c0 1.4-3.6 3-8 3zm0-5c-4.4 0-8-1.6-8-3s3.6-3 8-3 8 1.6 8 3-3.6 3-8 3z" fill="url(#sql-grad)"/>
        <defs>
          <linearGradient id="sql-grad" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
            <stop stopColor="#00758F"/>
            <stop offset="1" stopColor="#005A6F"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-cyan-500/10 to-teal-500/5",
  },
  figma: {
    name: "Figma",
    icon: (
      <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.5 2C6.6 2 5 3.6 5 5.5S6.6 9 8.5 9H12V2H8.5zm0 7c-1.9 0-3.5 1.6-3.5 3.5S6.6 16 8.5 16H12V9H8.5zm0 7c-1.9 0-3.5 1.6-3.5 3.5S6.6 23 8.5 23H12v-7H8.5z" fill="url(#fig-grad)"/>
        <path d="M15.5 9c1.9 0 3.5-1.6 3.5-3.5S17.4 2 15.5 2H12v7h3.5zm0 7c1.9 0 3.5-1.6 3.5-3.5S17.4 9 15.5 9h-3.5v7h3.5z" fill="url(#fig-grad)"/>
        <defs>
          <linearGradient id="fig-grad" x1="5" y1="2" x2="19" y2="23" gradientUnits="userSpaceOnUse">
            <stop stopColor="#F24E1E"/>
            <stop offset="0.5" stopColor="#A259FF"/>
            <stop offset="1" stopColor="#1ABC9C"/>
          </linearGradient>
        </defs>
      </svg>
    ),
    color: "from-red-500/10 to-purple-500/5",
  }
};

const getToolsForCourse = (course) => {
  const courseName = (course?.CourseName || "").toLowerCase();
  const category = (course?.category || "").toLowerCase();
  
  if (category.includes("ai") || category.includes("artificial") || category.includes("intelligence") || category.includes("generative") || courseName.includes("ai") || courseName.includes("machine learning")) {
    return [
      allTools.python,
      allTools.chatgpt,
      allTools.openai,
      allTools.huggingface,
      allTools.gemini,
      allTools.langchain,
      allTools.chromadb,
      allTools.streamlit
    ];
  }
  
  if (category.includes("web") || category.includes("frontend") || category.includes("backend") || category.includes("full stack") || courseName.includes("web") || courseName.includes("developer") || courseName.includes("react") || courseName.includes("javascript")) {
    return [
      allTools.react,
      allTools.nodejs,
      allTools.mongodb,
      allTools.sql,
      allTools.git,
      allTools.figma,
      allTools.python,
      allTools.chatgpt
    ];
  }
  
  if (category.includes("cloud") || category.includes("devops") || courseName.includes("aws") || courseName.includes("azure") || courseName.includes("cloud") || courseName.includes("docker")) {
    return [
      allTools.aws,
      allTools.git,
      allTools.nodejs,
      allTools.python,
      allTools.chatgpt
    ];
  }
  
  if (category.includes("data") || category.includes("analytic") || courseName.includes("data") || courseName.includes("analytic") || courseName.includes("sql") || courseName.includes("tableau")) {
    return [
      allTools.python,
      allTools.sql,
      allTools.chatgpt,
      allTools.figma,
      allTools.git
    ];
  }
  
  // Default general fallback
  return [
    allTools.python,
    allTools.chatgpt,
    allTools.git,
    allTools.figma
  ];
};

const ToolCovered = ({ course }) => {
  const tools = getToolsForCourse(course);
  const isAiCategory = (course?.category || "").toLowerCase().includes("ai") || (course?.category || "").toLowerCase().includes("generative");

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-left">
      <div className="max-w-3xl mb-12">
        <span className="pd-badge mb-4">
          <Sparkles size={11} className="text-blue-500 animate-pulse" />
          Technology Stack
        </span>
        <h2 className="text-4xl font-extrabold text-gray-900 tracking-tight leading-none mt-2">
          {tools.length}+ Tools Covered
        </h2>
        <p className="text-gray-500 text-sm mt-4 leading-relaxed">
          {isAiCategory 
            ? "Master the leading frameworks, LLMs, and development tools that drive modern AI products."
            : "Master the leading frameworks, libraries, and development tools that drive modern digital products."
          }
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 justify-items-stretch">
        {tools?.map((tool, index) => (
          <div
            key={index}
            className="relative flex flex-col items-center justify-center p-6 bg-white border border-gray-100 rounded-3xl hover:shadow-md hover:-translate-y-1 transition-all duration-300 group"
          >
            {/* Background Accent glow */}
            <div className={`absolute inset-0 bg-gradient-to-br ${tool.color} rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none`} />
            
            <div className="relative z-10 flex flex-col items-center">
              <div className="p-3 bg-gray-50 rounded-2xl group-hover:bg-white group-hover:scale-105 transition-all duration-300">
                {tool.icon}
              </div>
              <p className="text-sm font-bold text-gray-800 mt-4 tracking-wide group-hover:text-gray-900 transition-colors duration-300">
                {tool.name}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ToolCovered;
